export default "__VITE_ASSET__lflZRBEE__"